const serializeGroups = (groups) => groups.map(group => group.conditions
    .filter(condition => condition.fieldId && condition.operator)
    .map(condition => ({
    field: condition.fieldId,
    operator: condition.operator,
    values: condition.values,
})));
export const buildCampaignPayload = (state) => {
    // Formatar scheduled_at no formato esperado: "YYYY-MM-DD HH:mm:ss"
    let scheduledAt = null;
    if (state.settings.isScheduled && state.settings.scheduleDate && state.settings.scheduleTime) {
        scheduledAt = `${state.settings.scheduleDate} ${state.settings.scheduleTime}:00`;
    }
    return {
        name: state.settings.name,
        audienceId: state.settings.audienceId,
        title: state.settings.title,
        preheader: state.settings.preheader,
        senderName: state.settings.senderName,
        senderEmail: state.settings.senderEmail,
        categoryId: state.settings.categoryId,
        replyToEmail: state.settings.replyToEmail || state.settings.senderEmail,
        template: state.settings.template,
        isScheduled: state.settings.isScheduled,
        scheduleAt: scheduledAt,
        isRecurrent: state.settings.isRecurrent,
        notes: state.settings.notes || '',
        ipPoolName: state.settings.ipPoolName,
    };
};
